var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConditions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.70703 47.7907V2.20947H48.2883V47.7907H2.70703Z",
    stroke: "white",
    strokeWidth: 3.125
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6592 2.20947V22.7209L25.4965 18.1628L32.3338 22.7209V2.20947",
    stroke: "white",
    strokeWidth: 3.125
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0547 38.6744H39.1709",
    stroke: "white",
    strokeWidth: 3.125
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConditions);
export default __webpack_public_path__ + "static/media/conditions.fae947d38cddfce1d26f216214625380.svg";
export { ForwardRef as ReactComponent };